import { Component, Injector, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AbstractComponent, ContactService, Pager, User, UserService } from 'lib-trend-core';
import { EMPTY, switchMap } from 'rxjs';

@Component({
    selector: 'contact-component',
    templateUrl: 'contact.v2.component.html',
    // templateUrl: 'contact.component.html',
    styleUrl: 'contact.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactComponent extends AbstractComponent implements OnInit {

  pagerUser: Pager<User> = new Pager<User>({ perPage: 10 });

  activeTab: 'contacts' | 'group-contacts' | 'portifolio' = 'contacts';
  toggleTableCard: boolean = false;

  constructor(
    injector: Injector,
    public dialog: MatDialog,
    public contactService: ContactService,
    public userService: UserService,
  ) {
    super(injector);
    this.loadingContent = true;
  }

  ngOnInit(): void {
    this.getListUserWithCustomerPortfolio();
    const savedView = localStorage.getItem('tableCardView');
    this.toggleTableCard = savedView ? JSON.parse(savedView) : false;
  }

  private getListUserWithCustomerPortfolio(): void {
    this.contactService.getIdUserWithPortfolio().pipe(
      switchMap((list: Array<{ idUser: string }>) => {
        if (list.length === 0) {
          this.loadingContent = false;
          this.pagerUser = new Pager<User>({ page: 1, perPage: 10, total: 0 });
          return EMPTY;
        }
        const ids = Array.from(new Set(list.map(item => item.idUser)));
        return this.userService.getAll(1, 10, '', {
          company: this.getIDCurrentCompany(),
          ids: ids,
        });
      })
    ).subscribe({
      next: (pager: Pager<User>) => {
        this.pagerUser = pager;
        this.loadingContent = false;
      },
      error: (err) => {
        console.error('Erro ao buscar usuários com portfólio:', err);
        this.loadingContent = false;
      }
    });
  }

  toggleTableCards() {
    this.toggleTableCard = !this.toggleTableCard;
    localStorage.setItem('tableCardView', JSON.stringify(this.toggleTableCard));
  }

  loadPage(page: number) {
    this.pagerUser.page = page;
    this.getListUserWithCustomerPortfolio();
  }

  showContacts(item: User) {
    this.router.navigate(['/contact/customer-portfolio', item._id]);
  }

  setActiveTab(tab: typeof this.activeTab) {
    this.activeTab = tab;
  }

  get showToggle(): boolean {
    return this.activeTab !== 'portifolio';
  }
}
